import PropTypes from 'prop-types';

import MultiColumnLayout from '../MultiColumnLayout';

export const BannerIconCards = ({ data = null, containerClass = '' }) => {
  return (
    <MultiColumnLayout
      data={data}
      componentType="banner-icon-card"
      className={data.component}
      containerClass={containerClass}
    />
  );
};

BannerIconCards.propTypes = {
  data: PropTypes.shape(),
  containerClass: PropTypes.string,
};
